module.exports = __webpack_public_path__ + "img/thumbnail_TimberWolf_m_normal.7d2f0628.png";